import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "css-units"
    }}>{`CSS Units`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{` UXP v3.0`}</p>
    <p>{`UXP supports several CSS units to make layout easier. Units supported are `}<inlineCode parentName="p">{`em`}</inlineCode>{`, `}<inlineCode parentName="p">{`rem`}</inlineCode>{`, `}<inlineCode parentName="p">{`vh`}</inlineCode>{`, `}<inlineCode parentName="p">{`vw`}</inlineCode>{`, `}<inlineCode parentName="p">{`vmin`}</inlineCode>{`, `}<inlineCode parentName="p">{`vmax`}</inlineCode>{`, `}<inlineCode parentName="p">{`cm`}</inlineCode>{`, `}<inlineCode parentName="p">{`mm`}</inlineCode>{`, `}<inlineCode parentName="p">{`in`}</inlineCode>{`, `}<inlineCode parentName="p">{`pc`}</inlineCode>{`, `}<inlineCode parentName="p">{`pt`}</inlineCode>{`, `}<inlineCode parentName="p">{`px`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Values_and_Units#Relative_length_units"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Values_and_Units#Relative_length_units`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      